import { createApp, h } from 'vue';
import { HpsfirManageBaseUI, HpsfirManageBaseUIApp, HpsfirComponentsMap, HpsfirToaster } from 'hpsfir-managebase-ui';
import 'hpsfir-managebase-ui/lib/lib.css';
import './style/global.scss';
import { initApi } from './hooks/useApi';
import { brandTheme, applyBrandColor } from './theme';

/**
 * 管理后台入口（hpsfir-managebase-ui 1.0.0）。
 *
 * 1.0.0 的变化与迁移：
 *   1. 选项结构变了：adminLayoutCnt / loginCnt / errorCnt / commonCnt / themeOption 已移除；
 *      布局与登录页改由「主题」提供，见 ./theme。
 *   2. 框架不再内置 Element Plus（改为 shadcn-ui 体系），因此页面统一使用框架组件
 *      （HpsfirProTable / HpsfirProForm / HpsfirButton ...），不再注册 el-* 全局组件。
 *   3. 登录接口参数由 userNameOrPhone 改为 account（框架的 userStore 已适配）。
 *   4. 框架的 message（基于 vue-sonner）**需要应用自己挂载提示容器**：
 *      框架内没有任何组件渲染 HpsfirToaster，只导出该组件供应用使用。
 *      不挂载时 message.success()/error() 不会有任何可见反馈（旧版 Element Plus 会自挂载）。
 */

// 挂载全局消息提示容器（sonner），否则 message.* 无任何视觉反馈
const mountToaster = () => {
  const host = document.createElement('div');
  host.id = 'app-toaster';
  document.body.appendChild(host);
  createApp({ render: () => h(HpsfirToaster, { position: 'top-center', richColors: true }) }).mount(host);
};

const allComponents: HpsfirComponentsMap = {};
const viewRequireCnt = require.context('./views', true, /index\.vue$/u);
viewRequireCnt.keys().forEach((key) => {
  const keySplits = key.split('/');
  const dirname = keySplits[keySplits.length - 2];
  allComponents[dirname!] = () => viewRequireCnt(key).default || viewRequireCnt(key);
});

initApi('/api');

const app = createApp(HpsfirManageBaseUIApp);

app.use(HpsfirManageBaseUI, {
  siteName: '驿站助手',
  description: '管理后台',
  logo: '/favicon.svg',
  baseApiPath: '/api',
  viewMap: allComponents,
  theme: brandTheme,
});

// 主题注册后注入品牌色（必须晚于 app.use，否则会被主题的默认值覆盖）
applyBrandColor();

mountToaster();

app.mount('#app');
